export const EVENT_TYPES = {
  ITINERARY_EVENT: "ITINERARY-EVENT",
  ACCOMMODATION: "ACCOMMODATION",
  DESTINATION: "DESTINATION",
  ACTIVITY: "ACTIVITY",
};
